import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthComponent} from './layout/auth/auth.component';
import {AfterAuthComponent} from './layout/after-auth/after-auth.component';
import {LoggedComponent} from './layout/logged/logged.component';
import {AuthGuard} from './Services/auth.guard';
import {ExchangeComponent} from './layout/exchange/exchange.component';
import {LandingComponent} from './layout/landing/landing.component';
import {LoggedGuard} from './Services/logged.guard';
import {ResolverService} from './Services/resolver.service';
import {environment} from 'src/environments/environment';
// import { TermandconditionComponent } from './pages/termandcondition/termandcondition.component';


const routes = [
  {path: '', redirectTo: '/', pathMatch: 'full'},
  // {
  //   path: '',
  //   component: LandingComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     {
  //       path: 'market',
  //       loadChildren: () => import('./pages/market/market.module').then(m => m.MarketModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     // {
  //     //   path: 'buy-sell-market',
  //     //   loadChildren: () => import('./pages/buy-sell-public/buy-sell-public.module').then(m => m.BuySellPublicModule),
  //     //   canActivate: [LoggedGuard]

  //     //   // loadChildren: './pages/market/market.module#MarketModule'

  //     // },

  //     {
  //       path: 'simple-exchange-public/:coins',
  //       loadChildren: () => import('./pages/simple-exchange-public/simple-exchange-public.module').then(m => m.SimpleExchangePublicModule)
  //     },
  //     {
  //       path: 'quick-exchange-public',
  //       loadChildren: () => import('./pages/quick-exchange-public/quick-exchange-public.module').then(m => m.QuickExchangePublicModule)
  //     },
  //     {
  //       path: 'about-us',
  //       loadChildren: () => import('./pages/about/about.module').then(m => m.AboutModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     {
  //       path: 'fee',
  //       loadChildren: () => import('./pages/fee/fee.module').then(m => m.FeeModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     {
  //       path: 'privacy-policy',
  //       loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     {
  //       path: 'privacy-policy/:type',
  //       loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     {
  //       path: 'term-and-condition',
  //       loadChildren: () => import('./pages/termandcondition/termandcondition.module').then(m => m.TermandconditionModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     {
  //       path: 'term-and-condition/:type',
  //       loadChildren: () => import('./pages/termandcondition/termandcondition.module').then(m => m.TermandconditionModule),
  //       canActivate: [LoggedGuard]
  //     },
  //     {
  //       path: 'promo',
  //       loadChildren: () => import('./pages/promo/promo.module').then(m => m.PromoModule),
  //       canActivate: [LoggedGuard]
  //     },
  //   ]
  // },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
        // canActivate: [LoggedGuard]
      },
      {
        path: 'subscribe',
        loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'subscribe/:referralCode',
        loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
        // canActivate: [LoggedGuard]
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('./pages/forgot/forgot.module').then(m => m.ForgotModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'reset-password',
        loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'info',
        loadChildren: () => import('./pages/info/info.module').then(m => m.InfoModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'confirmation',
        loadChildren: () => import('./pages/confirm/confirm.module').then(m => m.ConfirmModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'verify-email',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
        // canActivate: [LoggedGuard]

        // loadChildren: './pages/confirm-success/confirm-success.module#ConfirmSuccessModule'
      },
      {
        path: 'verify-account',
        loadChildren: () => import('./pages/verify-account/verify-account.module').then(m => m.VerifyAccountModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'change-phone',
        loadChildren: () => import('./pages/change-phone/change-phone.module').then(m => m.ChangePhoneModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'check-sms-phone',
        loadChildren: () => import('./pages/check-sms-phone/check-sms-phone.module').then(m => m.CheckSmsPhoneModule),
        canActivate: [LoggedGuard]
      },
    ],

  },
  {
    path: '',
    component: AfterAuthComponent,
    children: [
      {
        path: 'start-verification',
        loadChildren: () => import('./pages/start-verification/start-verification.module').then(m => m.StartVerificationModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'verification-guide',
        loadChildren: () => import('./pages/user-verify-guide/user-verify-guide.module').then(m => m.UserVerifyGuideModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'verification-guide-obsicash',
        loadChildren: () => import('./pages/user-verify-guide-obsicash/user-verify-guide-obsicash.module').then(m => m.UserVerifyGuideObsicashModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'verification-error/:errorCode',
        loadChildren: () => import('./pages/netverify-error/netverify-error.module').then(m => m.NetverifyErrorModule),
        canActivate: [LoggedGuard]
      },
      {
        path: 'welcome',
        loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule),
        // canActivate: [LoggedGuard]
      },
      {
        path: 'verify',
        loadChildren: () => import('./pages/verify/verify.module').then(m => m.VerifyModule),
        // canActivate: [LoggedGuard]
      },
      {
        path: 'price-equation',
        loadChildren: () => import('./pages/price-equation/price-equation.module').then(m => m.PriceEquationModule),
        // canActivate: [LoggedGuard]
      },
      {
        path: 'profit-calculation',
        loadChildren: () => import('./pages/profit-calculation/profit-calculation.module').then(m => m.ProfitCalculationModule),
        // canActivate: [LoggedGuard]
      },
      {
        path: 'reputation-calculation',
        loadChildren: () => import('./pages/reputation-calculation/reputation-calculation.module').then(m => m.ReputationCalculationModule),
        // canActivate: [LoggedGuard]
      }
    ]
  },
  {
    path: '',
    component: ExchangeComponent,
    children: [
      {
        path: 'advance-exchange/:coins',
        loadChildren: () => import('./pages/exchange/exchange.module').then(m => m.ExchangeModule)
      }
    ]
  },
  {
    path: '',
    component: LoggedComponent,
    children: [
      // {
      //   path: 'exchange-select',
      //   loadChildren: './pages/exchange-select/exchange-select.module#ExchangeSelectModule'
      // },
      {
        path: 'quick-exchange',
        loadChildren: () => import('./pages/quick-exchange/quick-exchange.module').then(m => m.QuickExchangeModule)
      },
      {
        path: 'exchange',
        loadChildren: () => import('./pages/exchange/exchange.module').then(m => m.ExchangeModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages/user-info/user-info.module').then(m => m.UserInfoModule)
      },
      {
        path: 'profile/:tab',
        loadChildren: () => import('./pages/user-info/user-info.module').then(m => m.UserInfoModule)
      },
      {
        path: 'orders',
        loadChildren: () => import('./pages/orders/orders.module').then(m => m.OrdersModule)
      },
      {
        path: 'user-profile/:username',
        loadChildren: () => import('./pages/user-profile/user-profile.module').then(m => m.UserProfileModule)
      },
      {
        path: 'quick-transfer',
        loadChildren: () => import('./pages/quick-transfer/quick-transfer.module').then(m => m.QuickTransferModule)
      },
      // {
      //   path: 'quick-transfer',
      //   loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      // },
      {
        path: 'logged/privacy-policy',
        loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
      },
      {
        path: 'activity',
        loadChildren: () => import('./pages/activities/activities.module').then(m => m.ActivitiesModule)
      },
      {
        path: 'anti-phishing-enable',
        loadChildren: () => import('./pages/anti-phishing-enable/anti-phishing.module').then(m => m.AntiPhishingModule)
      },
      {
        path: 'anti-phishing-not-enable',
        loadChildren: () => import('./pages/anti-phishing-enable/anti-phishing.module').then(m => m.AntiPhishingModule)
      },
      {
        path: 'ip-management',
        loadChildren: () => import('./pages/ip-management/ip-management.module').then(m => m.IpManagementModule)
      },
      {
        path: 'wallet1',
        loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'wallet',
        loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletModule)
      },
      // {
      //   path: 'deposit',
      //   loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletModule)
      // },
      // {
      //   path: 'withdrawals',
      //   loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletModule)
      // },
      {
        path: 'deposit',
        loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'withdrawals',
        loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      },
      // {
      //   path: 'whitelist',
      //   loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletModule)
      // },
      {
        path: 'whitelist',
        loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      },
      // {
      //   path: 'transaction',
      //   loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletModule)
      // },
      {
        path: 'transaction',
        loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'prices',
        loadChildren: () => import('./pages/prices/prices.module').then(m => m.PricesModule)
      },
      {
        path: 'onboarding-business',
        loadChildren: () => import('./pages/onboarding-business/onboarding-business.module').then(m => m.OnboardingBusinessModule)
      },
      {
        path: 'transfer-history-old',
        loadChildren: () => import('./pages/transfer-history/transfer-history.module').then(m => m.TransferHistoryModule)
      },
      {
        path: 'transfer-history',
        loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      },
      // {
      //   path: 'transfer-history/:tab',
      //   loadChildren: () => import('./pages/transfer-history/transfer-history.module').then(m => m.TransferHistoryModule)
      // },
      {
        path: 'transfer-history/:tab',
        loadChildren: () => import('./pages/send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'simple-exchange/:coins',
        loadChildren: () => import('./pages/simple-exchange/simple-exchange.module').then(m => m.SimpleExchangeModule)
      },
      {
        path: 'dashboard-old',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard-new/dashboard-new.module').then(m => m.DashboardNewModule)
      },
      {
        path: 'obsicash',
        loadChildren: () => import('src/app/pages/obsicash/obsicash.module').then(m => m.ObsicashModule)
      },
      {
        path: 'quantum',
       loadChildren: () => import('./pages/quantum/quantum.module').then(m => m.QuantumModule)
      },
      {
        path: 'buy-sell',
        loadChildren: () => import('./pages/buy-sell/buy-sell.module').then(m => m.BuySellModule)
      },
      {
        path: 'private-trade',
        loadChildren: () => import('./pages/private-trade/private-trade.module').then(m => m.PrivateTradeModule)
      },
      {
        path: 'payment',
        loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule)
      },
      {
        path: 'buy-sell-detail/:type/:coinId',
        loadChildren: () => import('./pages/buy-sell-detail/buy-sell-detail.module').then(m => m.BuySellDetailModule),
        resolve: {
          auth: ResolverService
        }
      },
      {
        path: 'trade-window/:actionId',
        loadChildren: () => import('./pages/trade-window/trade-window.module').then(m => m.TradeWindowModule),
        resolve: {
          auth: ResolverService
        }
      },
      {
        path: 'tutorials',
        loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialModule)
      },
      {
        path: 'tutorial-detail',
        loadChildren: () => import('./pages/tutorial-detail/tutorial-detail.module').then(m => m.TutorialDetailModule)
      },
      {
        path: 'tutorial-detail/:introductionTutorial',
        loadChildren: () => import('./pages/tutorial-detail/tutorial-detail.module').then(m => m.TutorialDetailModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationModule),
      },
      {
        path: 'announcements',
        loadChildren: () => import('./pages/announcement/announcement.module').then(m => m.AnnouncementModule)
      },
      {
        path: '404',
        loadChildren: () => import('./pages/page404/page404.module').then(m => m.Page404Module)
      },
      {
        path: 'comming-soon',
        loadChildren: () => import('./pages/page-coming-soon/page-coming-soon.module').then(m => m.PageComingSoonModule)
      },
      {
        path: 'comming-soon-1',
        children: [
          {
            path: 'url-1',
            loadChildren: () => import('./pages/simple-exchange/simple-exchange.module').then(m => m.SimpleExchangeModule)
          },
          {
            path: 'url-2',
            loadChildren: () => import('./pages/quick-exchange/quick-exchange.module').then(m => m.QuickExchangeModule)
          },
          {
            path: 'url-3',
            loadChildren: () => import('./pages/exchange/exchange.module').then(m => m.ExchangeModule)
          },
          {
            path: 'url-4',
            loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule)
          },
          {
            path: 'url-5',
            loadChildren: () => import('./pages/simple-exchange-public/simple-exchange-public.module').then(m => m.SimpleExchangePublicModule)
          },
          {
            path: 'url-6',
            loadChildren: () => import('./pages/quick-exchange-public/quick-exchange-public.module').then(m => m.QuickExchangePublicModule)
          },
        ]
      },
      {
        path: 'not-connected',
        loadChildren: () => import('./pages/not-connected/not-connected.module').then(m => m.NotConnectedModule)
      },
    ],
    canActivate: [AuthGuard]
  }
    ,
  {path: '**', redirectTo: '/dashboard'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}

